require('dotenv').config()

export const loginNodeBaseURL = process.env.REACT_APP_BACKEND_URL;
export const nodeBaseURL = process.env.REACT_APP_BACKEND_URL;
export const notificationURL = process.env.REACT_APP_BACKEND_URL;
export const pusherBeamsInstanceID = process.env.REACT_APP_BEAMS_KEY;
export const pusherKey = process.env.REACT_APP_PUSHER_KEY;
export const phoneNo = process.env.REACT_APP_PHONE_NO;